import BaseModel from '../base/BaseModel.model';
export default class AnnoucementResearchArea extends BaseModel {

    areaId: number =  0;
    areaName: string ="";

    fieldAreaId: number =  0;
    fieldAreaName: string ="";

    researchLineId: number =  0;
    researchLineName: string ="";

    init(){
        this.areaId = 0;
        this.areaName  ="";

        this.fieldAreaId = 0;
        this.fieldAreaName  ="";

        this.researchLineId = 0;
        this.researchLineName ="";
    }
}